export default __webpack_public_path__ + "static/media/renaissanceIcon.76425ab6.svg";